import { VisibilitySiteSettings } from '@/modules/creator-settings/ui/visibility-site/VisibilitySite.tsx'

export const VisibilitySiteView = () => {
  return <VisibilitySiteSettings />
}
